import { FC } from 'react';

import Image from 'next/image';

import { HeroCampaignBannerContainer } from '@components/ui/banners/hero-campaign-banner/HeroCampaignBannerStyles';

export interface BannerDeatailProps {
  url?: string;
  alt?: string;
}

export const BannerDeatail: FC<BannerDeatailProps> = ({ url, alt }) => {
  return (
    <>
      <HeroCampaignBannerContainer>
        {url ? (
          <Image
            src={url}
            fill
            style={{
              objectFit: 'initial',
            }}
            alt={alt || 'shop&fly'}
          />
        ) : null}
      </HeroCampaignBannerContainer>
    </>
  );
};

export default BannerDeatail;
